const validDrugs = new Set<string>([
  "abacavir",
  "abaloparatide",
  "abametapir",
  "abatacept",
  "abemaciclib",
  "abiraterone",
  "abrocitinib",
  "acalabrutinib",
  "acarbose",
  "acetaminophen",
  "acetazolamide",
  "acetylcysteine",
  "acitretin",
  "acyclovir",
  "adagrasib",
  "adalimumab",
  "adapalene",
  "adenosine",
  "afamelanotide",
  "afatinib",
  "aflibercept",
  "air",
  "albendazole",
  "albuterol",
  "alcaftadine",
  "alcohol",
  "aldesleukin",
  "alemtuzumab",
  "alirocumab",
  "aliskiren",
  "alitretinoin",
  "allopurinol",
  "almotriptan",
  "alogliptin",
  "alosetron",
  "alpelisib",
  "alprazolam",
  "alprostadil",
  "alteplase",
  "alvimopan",
  "amantadine",
  "ambrisentan",
  "amcinonide",
  "amikacin",
  "aminophylline",
  "amisulpride",
  "amivantamab",
  "amlodipine",
  "amoxapine",
  "amoxicillin",
  "amphetamine",
  "ampicillin",
  "anagrelide",
  "anakinra",
  "anastrozole",
  "anidulafungin",
  "ansuvimab",
  "apalutamide",
  "apixaban",
  "apraclonidine",
  "apremilast",
  "aprepitant",
  "aprocitentan",
  "argatroban",
  "aripiprazole",
  "armodafinil",
  "asciminib",
  "asenapine",
  "aspirin",
  "atazanavir",
  "atenolol",
  "atezolizumab",
  "atogepant",
  "atomoxetine",
  "atorvaliq",
  "atovaquone",
  "atrasentan",
  "atropine",
  "auranofin",
  "avacopan",
  "avanafil",
  "avapritinib",
  "avelumab",
  "axitinib",
  "azacitidine",
  "azathioprine",
  "azelastine",
  "azithromycin",
  "aztreonam",
  "bacitracin",
  "baclofen",
  "baricitinib",
  "basiliximab",
  "becaplermin",
  "belatacept",
  "belimumab",
  "belinostat",
  "belumosudil",
  "belzutifan",
  "benralizumab",
  "benznidazole",
  "benzonatate",
  "benztropine",
  "beractant",
  "berdazimer",
  "besifloxacin",
  "betaine",
  "betaxolol",
  "betiatide",
  "bevacizumab",
  "bexagliflozin",
  "bexarotene",
  "bezlotoxumab",
  "bicalutamide",
  "bimatoprost",
  "bimekizumab",
  "binimetinib",
  "bivalirudin",
  "bleomycin",
  "blinatumomab",
  "bortezomib",
  "bosentan",
  "bosutinib",
  "bremelanotide",
  "brexpiprazole",
  "brigatinib",
  "brimonidine",
  "brincidofovir",
  "brinzolamide",
  "brivaracetam",
  "brodalumab",
  "brolucizumab",
  "bromfenac",
  "budesonide",
  "bumetanide",
  "bupivacaine",
  "buprenorphine",
  "bupropion",
  "burosumab",
  "busulfan",
  "cabazitaxel",
  "cabergoline",
  "cabotegravir",
  "cabozantinib",
  "calcifediol",
  "calcipotriene",
  "calcitriol",
  "calfactant",
  "canagliflozin",
  "canakinumab",
  "candesartan",
  "cangrelor",
  "cannabidiol",
  "cantharidin",
  "capecitabine",
  "capivasertib",
  "caplacizumab",
  "capmatinib",
  "capsaicin",
  "captopril",
  "carbachol",
  "carbamazepine",
  "carbidopa",
  "carboplatin",
  "carfilzomib",
  "cariprazine",
  "carisoprodol",
  "carmustine",
  "carvedilol",
  "casimersen",
  "cefaclor",
  "cefadroxil",
  "cefazolin",
  "cefdinir",
  "cefepime",
  "cefixime",
  "cefotaxime",
  "cefotetan",
  "cefoxitin",
  "cefprozil",
  "ceftazidime",
  "ceftriaxone",
  "cefuroxime",
  "celecoxib",
  "cephalexin",
  "ceritinib",
  "cetirizine",
  "cetuximab",
  "chenodiol",
  "chlorambucil",
  "chlorothiazide",
  "chlorpromazine",
  "chlorthalidone",
  "chlorzoxazone",
  "cholestyramine",
  "ciclesonide",
  "ciclopirox",
  "cilostazol",
  "cimetidine",
  "cinacalcet",
  "ciprofloxacin",
  "cisplatin",
  "citalopram",
  "cladribine",
  "clarithromycin",
  "clascoterone",
  "clevidipine",
  "clobazam",
  "clofarabine",
  "clonazepam",
  "clonidine",
  "clopidogrel",
  "clotrimazole",
  "clozapine",
  "cobicistat",
  "cobimetinib",
  "colchicine",
  "colesevelam",
  "colistimethate",
  "concizumab",
  "copper",
  "cosyntropin",
  "crinecerfont",
  "crisaborole",
  "crizanlizumab",
  "crizotinib",
  "crofelemer",
  "crotamiton",
  "crovalimab",
  "cyanocobalamin",
  "cycloserine",
  "cyclosporine",
  "cytarabine",
  "dabrafenib",
  "dacarbazine",
  "dacomitinib",
  "dactinomycin",
  "dalbavancin",
  "dalfampridine",
  "danazol",
  "danicopan",
  "dantrolene",
  "dapagliflozin",
  "dapiprazole",
  "daprodustat",
  "dapsone",
  "daptomycin",
  "daratumumab",
  "daridorexant",
  "darifenacin",
  "darolutamide",
  "darunavir",
  "dasatinib",
  "dasiglucagon",
  "daspone",
  "decitabine",
  "deferasirox",
  "deferiprone",
  "deflazacort",
  "degarelix",
  "demeclocycline",
  "denosumab",
  "desflurane",
  "desipramine",
  "desloratadine",
  "desonide",
  "desoximetasone",
  "desvenlafaxine",
  "dexamethasone",
  "dexrazoxane",
  "dextrose",
  "diazepam",
  "diazoxide",
  "diclofenac",
  "difelikefalin",
  "diflunisal",
  "difluprednate",
  "digoxin",
  "dimenhydrinate",
  "dinoprostone",
  "dinutuximab",
  "dipyridamole",
  "disulfiram",
  "dobutamine",
  "docetaxel",
  "docosanol",
  "dofetilide",
  "doravirine",
  "dorzolamide",
  "dostarlimab",
  "doxazosin",
  "doxepin",
  "doxorubicin",
  "doxycycline",
  "dronabinol",
  "dronedarone",
  "droperidol",
  "drospirenone",
  "droxidopa",
  "dulaglutide",
  "duloxetine",
  "dupilumab",
  "durvalumab",
  "dutasteride",
  "duvelisib",
  "ecallantide",
  "eculizumab",
  "edaravone",
  "efavirenz",
  "efinaconazole",
  "elacestrant",
  "elafibranor",
  "elagolix",
  "eliglustat",
  "elotuzumab",
  "eltrombopag",
  "eluxadoline",
  "emicizumab",
  "empagliflozin",
  "emtricitabine",
  "enalapril",
  "enalaprilat",
  "encorafenib",
  "enfuvirtide",
  "ensartinib",
  "ensifentrine",
  "entacapone",
  "entecavir",
  "entrectinib",
  "enzalutamide",
  "epinephrine",
  "eplerenone",
  "eplontersen",
  "epoprostenol",
  "eptifibatide",
  "eravacycline",
  "erdafitinib",
  "ergocalciferol",
  "erlotinib",
  "ertapenem",
  "ertugliflozin",
  "erythromycin",
  "erythropoietin",
  "escitalopram",
  "escitslopram",
  "esomeprazole",
  "estazolam",
  "estradiol",
  "eszopiclone",
  "etanercept",
  "etelcalcetide",
  "eteplirsen",
  "ethionamide",
  "ethosuximide",
  "etodolac",
  "etomidate",
  "etonogestrel",
  "etoposide",
  "etrasimod",
  "etravirine",
  "everolimus",
  "evinacumab",
  "evolocumab",
  "exemestane",
  "exenatide",
  "ezetimibe",
  "famciclovir",
  "famotidine",
  "faricimab",
  "febuxostat",
  "felbamate",
  "felodipine",
  "fenfluramine",
  "fenofibrate",
  "fentanyl",
  "ferumoxytol",
  "fexinidazole",
  "fezolinetant",
  "fidaxomicin",
  "filgrastim",
  "finasteride",
  "finerenone",
  "fingolimod",
  "fitusiran",
  "flibanserin",
  "floxuridine",
  "fluconazole",
  "flucytosine",
  "flumazenil",
  "flunisolide",
  "fluocinonide",
  "fluorescein",
  "fluorouracil",
  "fluoxetine",
  "flurbiprofen",
  "flutamide",
  "fluvastatin",
  "follitropin",
  "fomepizole",
  "fosaprepitant",
  "fosinopril",
  "fostamatinib",
  "fruquintinib",
  "fulvestrant",
  "furosemide",
  "futibatinib",
  "gabapentin",
  "gadobutrol",
  "gadodiamide",
  "gadopiclenol",
  "gadoteridol",
  "galantamine",
  "galsulfase",
  "ganaxolone",
  "ganciclovir",
  "gatifloxacin",
  "gaunfacine",
  "gefitinib",
  "gemcitabine",
  "gemfibrozil",
  "gentamicin",
  "gepirone",
  "gepotidacin",
  "gilteritinib",
  "givinostat",
  "glasdegib",
  "glatiramer",
  "glimepiride",
  "glipizide",
  "glofitamab",
  "glucagon",
  "glucarpidase",
  "glutamine",
  "glyburide",
  "glycine",
  "glycopyrrolate",
  "glycopyrronium",
  "golimumab",
  "golodirsen",
  "goserelin",
  "gozetotide",
  "granisetron",
  "griseofulvin",
  "grisofulvin",
  "guaifenesin",
  "guanfacine",
  "guselkumab",
  "halcinonide",
  "haloperidol",
  "helium",
  "hyaluronidase",
  "hydrocortisone",
  "hydroxyurea",
  "hydroxyzine",
  "ibalizumab",
  "ibrexafungerp",
  "ibrutinib",
  "ibuprofen",
  "icatibant",
  "idarucizumab",
  "idelalisib",
  "idursulfase",
  "ifosfamide",
  "iloperidone",
  "iloprost",
  "imatinib",
  "imiglucerase",
  "imiquimod",
  "inavolisib",
  "inclisiran",
  "indapamide",
  "indomethacin",
  "inebilizumab",
  "infliximab",
  "inotersen",
  "iodixanol",
  "iohexol",
  "iopamidol",
  "iopromide",
  "ioversol",
  "ipilimumab",
  "iptacopan",
  "irbesartan",
  "isatuximab",
  "isoflurane",
  "isoniazid",
  "isotretinoin",
  "isradipine",
  "istradefylline",
  "itraconazole",
  "ivabradine",
  "ivacaftor",
  "ivermectin",
  "ivosidenib",
  "ixabepilone",
  "ixazomib",
  "ixekizumab",
  "ketoconazole",
  "ketoprofen",
  "lacosamide",
  "lactulose",
  "lamivudine",
  "lamotrigine",
  "landiolol",
  "lansoprazole",
  "lapatinib",
  "laronidase",
  "larotrectinib",
  "lasmiditan",
  "latanoprost",
  "lazertinib",
  "lecanemab",
  "leflunomide",
  "lemborexant",
  "lenalidomide",
  "leniolisib",
  "lenvatinib",
  "letermovir",
  "letrozole",
  "leuprolide",
  "levalbuterol",
  "levamlodipine",
  "levetiracetam",
  "levocarnitine",
  "levodopa",
  "levofloxacin",
  "levoleucovorin",
  "levonorgestrel",
  "lidocaine",
  "lifitegrast",
  "linaclotide",
  "linagliptin",
  "lincomycin",
  "linezolid",
  "liraglutide",
  "lisinopril",
  "lithium",
  "lofexidine",
  "lomustine",
  "lonafarnib",
  "loratadine",
  "lorazepam",
  "lorlatinib",
  "losartan",
  "lovastatin",
  "loxapine",
  "lubiprostone",
  "luliconazole",
  "lumasiran",
  "lumateperone",
  "lurbinectedin",
  "luspatercept",
  "lusutrombopag",
  "macitentan",
  "malathion",
  "mannitol",
  "maraviroc",
  "maribavir",
  "mavacamten",
  "mavorixafor",
  "mebendazole",
  "mebrofenin",
  "mecasermin",
  "meclizine",
  "meloxicam",
  "melphalan",
  "memantine",
  "menotropins",
  "mepolizumab",
  "meprobamate",
  "mercaptopurine",
  "meropenem",
  "mesalamine",
  "mesna",
  "metaxalone",
  "metformin",
  "methadone",
  "methazolamide",
  "methimazole",
  "methocarbamol",
  "methotrexate",
  "methoxsalen",
  "methsuximide",
  "methyldopa",
  "metoclopramide",
  "metolazone",
  "metoprolol",
  "metreleptin",
  "metronidazole",
  "metyrapone",
  "metyrosine",
  "micafungin",
  "miconazole",
  "midazolam",
  "mifepristone",
  "miglitol",
  "miglustat",
  "miltefosine",
  "minocycline",
  "minoxidil",
  "mirabegron",
  "mirdametinib",
  "mirtazapine",
  "misoprostol",
  "mitapivat",
  "mitomycin",
  "mitotane",
  "mitoxantrone",
  "modafinil",
  "momelotinib",
  "mometasone",
  "montelukast",
  "mosunetuzumab",
  "motixafortide",
  "moxidectin",
  "moxifloxacin",
  "mupirocin",
  "nabilone",
  "nabumetone",
  "nadolol",
  "nafcillin",
  "naldemedine",
  "naloxone",
  "naltrexone",
  "naproxen",
  "naratriptan",
  "natalizumab",
  "natamycin",
  "nateglinide",
  "naxitamab",
  "nebivolol",
  "necitumumab",
  "nedosiran",
  "nelarabine",
  "neostigmine",
  "nepafenac",
  "neratinib",
  "netarsudil",
  "nevirapine",
  "niacin",
  "nicardipine",
  "nicotine",
  "nifedipine",
  "nifurtimox",
  "nilotinib",
  "nilutamide",
  "nimodipine",
  "nintedanib",
  "nipocalimab",
  "niraparib",
  "nirogacestat",
  "nirsevimab",
  "nisoldipine",
  "nitazoxanide",
  "nitisinone",
  "nitrofurantion",
  "nitrofurantoin",
  "nitrogen",
  "nitroglycerin",
  "nivolumab",
  "nizatidine",
  "norethindrone",
  "norgestrel",
  "nusinersen",
  "nystatin",
  "obiltoxaximab",
  "obinutuzumab",
  "ocrelizumab",
  "octreotide",
  "odevixibat",
  "ofatumumab",
  "ofloxacin",
  "olanzapine",
  "olaparib",
  "oliceridine",
  "olopatadine",
  "olutasidenib",
  "omadacycline",
  "omalizumab",
  "omaveloxolone",
  "omeprazole",
  "ondansetron",
  "opicapone",
  "oritavancin",
  "orlistat",
  "oseltamivir",
  "osilodrostat",
  "osimertinib",
  "ospemifene",
  "oteseconazole",
  "oxacillin",
  "oxaliplatin",
  "oxandrolone",
  "oxaprozin",
  "oxazepam",
  "oxcarbazepine",
  "oxybutynin",
  "oxycodone",
  "oxygen",
  "oxytocin",
  "paclitaxel",
  "pacritinib",
  "palbociclib",
  "palifermin",
  "paliperidone",
  "palivizumab",
  "palonosetron",
  "palovarotene",
  "pancrelipase",
  "panitumumab",
  "pantoprazole",
  "paricalcitol",
  "paroxetine",
  "pasireotide",
  "patiromer",
  "patisiran",
  "pazopanib",
  "pegaspargase",
  "pegcetacoplan",
  "pegfilgrastim",
  "pegloticase",
  "pegulicianine",
  "pegvisomant",
  "pembrolizumab",
  "pemetrexed",
  "pemigatinib",
  "penciclovir",
  "penicillamine",
  "penpulimab",
  "pentostatin",
  "pentoxifylline",
  "peramivir",
  "perampanel",
  "perflutren",
  "permethrin",
  "perphenazine",
  "pertuzumab",
  "phenytoin",
  "phytonadione",
  "pimecrolimus",
  "pimozide",
  "pindolol",
  "pioglitazone",
  "pirfenidone",
  "piroxicam",
  "pirtobrutinib",
  "pitavastatin",
  "plazomicin",
  "plecanatide",
  "plerixafor",
  "podofilox",
  "polidocanol",
  "pomalidomide",
  "ponesimod",
  "posaconazole",
  "pozelimab",
  "pralatrexate",
  "pralsetinib",
  "prasterone",
  "prasugrel",
  "praziquantel",
  "prazosin",
  "prednisolone",
  "prednisone",
  "pregabalin",
  "pretomanid",
  "primidone",
  "probenecid",
  "progesterone",
  "promethazine",
  "propafenone",
  "propofol",
  "prucalopride",
  "purixan",
  "pyrazinamide",
  "pyrimethamine",
  "quazepam",
  "quetiapine",
  "quinapril",
  "quinine",
  "quizartinib",
  "rabeprazole",
  "raloxifene",
  "raltegravir",
  "ramelteon",
  "ramipril",
  "ramucirumab",
  "ranibizumab",
  "ranitidine",
  "ranolazine",
  "rasagiline",
  "rasburicase",
  "ravulizumab",
  "raxibacumab",
  "regadenoson",
  "regorafenib",
  "relugolix",
  "remdesivir",
  "repaglinide",
  "repotrectinib",
  "reslizumab",
  "resmetirom",
  "revefenacin",
  "revumenib",
  "rezafungin",
  "ribavirin",
  "ribociclib",
  "rifabutin",
  "rifampin",
  "rifapentine",
  "rifaximin",
  "rilonacept",
  "riluzole",
  "riociguat",
  "ripretinib",
  "risdiplam",
  "risperidone",
  "ritlecitinib",
  "ritonavir",
  "rituximab",
  "rivaroxaban",
  "rivastigmine",
  "rizatriptan",
  "robinul",
  "rocuronium",
  "roflumilast",
  "rolapitant",
  "romidepsin",
  "romiplostim",
  "ropinirole",
  "rosuvastatin",
  "rotigotine",
  "rucaparib",
  "rufinamide",
  "ruxolitinib",
  "rydapt",
  "sacrosidase",
  "sargramostim",
  "sarilumab",
  "satralizumab",
  "saxagliptin",
  "scopolamine",
  "secnidazole",
  "secukinumab",
  "selegiline",
  "selexipag",
  "selinexor",
  "selpercatinib",
  "selumetinib",
  "semaglutide",
  "sertraline",
  "setmelanotide",
  "sevoflurane",
  "sildenafil",
  "silodosin",
  "siltuximab",
  "simvastatin",
  "sincalide",
  "sinecatechins",
  "siponimod",
  "sirolimus",
  "sitagliptin",
  "smoflipid",
  "sofosbuvir",
  "solriamfetol",
  "somatropin",
  "sonidegib",
  "sorafenib",
  "sorbitol",
  "sotagliflozin",
  "sotorasib",
  "sparsentan",
  "spinosad",
  "spironolactone",
  "stiripentol",
  "streptomycin",
  "succimer",
  "sucralfate",
  "sufentanil",
  "sugammadex",
  "sulfadiazine",
  "sulfasalazine",
  "sulindac",
  "sumatriptan",
  "suvorexant",
  "suzetrigine",
  "tacrolimus",
  "tadalafil",
  "tafamidis",
  "tafenoquine",
  "tafluprost",
  "tagraxofusp",
  "talazoparib",
  "talc",
  "talquetamab",
  "tapinarof",
  "tasimelteon",
  "tavaborole",
  "tazarotene",
  "tazemetostat",
  "tebentafusp",
  "teclistamab",
  "teduglutide",
  "telmisartan",
  "temazepam",
  "temozolomide",
  "temsirolimus",
  "tenapanor",
  "tenecteplase",
  "teprotumumab",
  "terazosin",
  "terbinafine",
  "terconazole",
  "teriflunomide",
  "teriparatide",
  "terlipressin",
  "tesamorelin",
  "testosterone",
  "tetrabenazine",
  "tetrofosmin",
  "thalidomide",
  "theophylline",
  "thioguanine",
  "thiotepa",
  "thiothixene",
  "tiagabine",
  "ticagrelor",
  "tigecycline",
  "tilmanocept",
  "timolol",
  "tinidazole",
  "tioconazole",
  "tiopronin",
  "tipranavir",
  "tirbanibulin",
  "tirofiban",
  "tirzepatide",
  "tivozanib",
  "tizanidine",
  "tobramycin",
  "tocilizumab",
  "tofacitinib",
  "tofersen",
  "tolcapone",
  "tolterodine",
  "tolvaptan",
  "topiramate",
  "topotecan",
  "torsemide",
  "tovorafenib",
  "trabectedin",
  "trametinib",
  "trandolapril",
  "trastuzumab",
  "travoprost",
  "tremelimumab",
  "treosulfan",
  "treprostinil",
  "tretinoin",
  "triamterene",
  "triazolam",
  "trifarotene",
  "trifluridine",
  "triheptanoin",
  "trilaciclib",
  "trimethoprim",
  "triptorelin",
  "trofinetide",
  "tromethamine",
  "tropicamide",
  "tucatinib",
  "ublituximab",
  "ubrogepant",
  "umeclidinium",
  "upadacitinib",
  "ursodiol",
  "ursosiol",
  "ustekinumab",
  "vadadustat",
  "valacyclovir",
  "valbenazine",
  "valganciclovir",
  "valrubicin",
  "valsartan",
  "vamorolone",
  "vancomycin",
  "vandetanib",
  "vardenafil",
  "varenicline",
  "vasopressin",
  "vedolizumab",
  "vemurafenib",
  "venetoclax",
  "venlafaxine",
  "vericiguat",
  "vibegron",
  "vigabatrin",
  "viltolarsen",
  "vimseltinib",
  "vinorelbine",
  "vismodegib",
  "voclosporin",
  "vorasidenib",
  "voriconazole",
  "vorinostat",
  "vortioxetine",
  "vosoritide",
  "voxelotor",
  "vutrisiran",
  "warfarin",
  "water",
  "xenon",
  "zafirlukast",
  "zaleplon",
  "zanamivir",
  "zanubrutinib",
  "zavegepant",
  "zenocutuzumab",
  "zidovudine",
  "zileuton",
  "zilucoplan",
  "ziprasidone",
  "zolbetuximab",
  "zolmitriptan",
  "zonisamide",
  "zuranolone",
]);

export default validDrugs;
